<div class="d-flex flex-column">
  <div *ngFor="let tag of this.tags ; trackBy: trackByIcon" class="mr-1">
    <mdb-badge [color]="tag.color" mdbTooltip="{{ tag.text | translate:tag.params }}" placement="bottom" class="z-depth-0">
      <i class="fa-fw fa-{{ tag.icon }} fas white-text animated rotateIn mr-1"></i>{{ tag.title | translate }}
    </mdb-badge>
  </div>
</div>